export const actionDisabled = (
  clusterRoleBinding,
  authoritiesList,
  action?: string,
  clusterId?: string,
  actionsList?: string[],
) => {
  let tempActionsList: string[] = [];
  //If a particular button is accessible by any role, then there is no permission assigned for that action.
  //For such buttons disabled should be false.
  if (!action && !actionsList?.length) {
    return false;
  }
  //If the cluster has some cluster specific role, action is prefixed with clusterId and then searched in authorities
  if (clusterId) {
    if (
      Object.keys(clusterRoleBinding).length > 0 &&
      Object.keys(clusterRoleBinding).indexOf(clusterId) !== -1
    ) {
      //if action passed as input is an array, then attach cluster id before each action
      //as all the permissions for that cluster will be cluster specific.
      if (actionsList?.length > 0) {
        tempActionsList = actionsList?.map((eachAction) => {
          return clusterId + '_' + eachAction;
        });
      } else {
        action = clusterId + '_' + action;
      }
    } else {
      tempActionsList = actionsList?.length > 0 ? [...actionsList] : [];
    }
  }
  if (actionsList?.length > 0) {
    return !tempActionsList.some((act) => authoritiesList.includes(act));
  } else {
    return !authoritiesList.includes(action);
  }
};
